@if (dataIsLoaded) {
  <section class="fourofour-error">
    <br /><br /><br /><br /><br /><br /><br />
    <h1 [innerHTML]="data.page_title"></h1>
  </section>
}
